<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="title is-1">IDERA Extension:</div>
      <div v-if="questions && questions.length > 0">
        <question v-model="questions[0]" @change="change($event, '0')"></question>
        <div v-if="recording">
          <question v-model="questions[1]" v-if="registryAuthority" @change="change($event, '1')"></question>
          <question v-model="questions[2]" v-show="officialTimetable" @change="change($event, '2')"></question>
          <question v-model="questions[3]" v-show="notOfficialTimetable" @change="change($event, '3')"></question>
          <question v-model="questions[4]" @change="change($event, '4')" column></question>
          <question v-model="questions[5]" v-if="issued" @change="change($event, '5')"></question>
          <hr />
          <question v-model="questions[6]" @change="change($event, '6')" column></question>
          <question v-model="questions[7]" @change="change($event, '7')"></question>
          <question v-model="questions[8]" @change="change($event, '8')"></question>
          <hr />
          <question v-model="questions[9]" @change="change($event, '9')"></question>
          <question v-model="questions[10]" v-if="enforcedTimetable" @change="change($event, '10')" column></question>
          <hr />
          <question v-model="questions[11]" @change="change($event, '11')" column></question>
          <question v-model="questions[12]" v-if="registrationCertificate" @change="change($event, '12')" column></question>
          <question v-model="questions[13]" v-if="airworthinessCertificate" @change="change($event, '13')" column></question>
          <question v-model="questions[14]" @change="change($event, '14')" column></question>
          <hr />
          <question v-model="questions[15]" @change="change($event, '15')"></question>
          <question v-model="questions[16]" v-if="exportProcedures" @change="change($event, '16')" column></question>
        </div>
      </div>
      <br /><br />
      <div v-if="IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/0')">Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/2')">Next</b-button>
          </div>
        </div>
      </div>
      <div v-if="!IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button class="button is-primary" @click="save">Save</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: [],
        ideraDeclaration: false
      }
    },
    props: {
      exporting: Boolean
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/0');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/2');
        });
      },
      async save() {
        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.Idera);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.Idera);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      var p1 =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.Idera, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');
              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });
      var p2 =
        this.$http.get("api/questionnaire/ideraDeclaration/" + Id)
          .then(resp => {
            this.ideraDeclaration = resp.data;
          }).catch(err => {
            console.error(err);
          });
      this.qpromise = [p1, p2];

      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      var self = this;
      Promise.all(this.qpromise).then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },
    computed: {
      exportProcedures() {
        if (this.questions[15].model && this.questions[15].model == 44) {
          return true;
        } else {
          if (this.questions[16].model) {
            this.questions[16].model = null;
          }
          return false;
        }
      },
      registrationCertificate() {
        if (this.questions[11].model && this.questions[11].model.some(model => model == 39)) {
          return true;
        } else {
          if (this.questions[12].model) {
            this.questions[12].model = null;
          }
          return false;
        }
      },
      airworthinessCertificate() {
        if (this.questions[11].model && this.questions[11].model.some(model => model == 40)) {
          return true;
        } else {
          if (this.questions[13].model) {
            this.questions[13].model = null;
          }
          return false;
        }
      },
      enforcedTimetable() {
        if (this.questions[9].model && this.questions[9].model == 36) {
          return true;
        } else {
          if (this.questions[10].model) {
            this.questions[10].model = null;
          }
          return false;
        }
      },
      issued() {
        if (this.questions[4].model && this.questions[4].model == 27 || this.questions[4].model == 29) {
          return true;
        } else {
          if (this.questions[5].model) {
            this.questions[5].model = null;
          }
          return false;
        }
      },
      notOfficialTimetable() {
        if (this.questions[1].model && this.questions[1].model == 26) {
          return true;
        } else {
          if (this.questions[3].model) {
            this.questions[3].model = null;
          }
          return false;
        }
      },
      officialTimetable() {
        if (this.questions[1].model && this.questions[1].model == 25) {
          return true;
        } else {
          if (this.questions[2].model) {
            this.questions[2].model = null;
          }
          return false;
        }
      },
      registryAuthority() {
        if (this.questions[0].model && this.questions[0].model == 23) {
          return true;
        } else {
          return false;
        }
      },
      recording() {
        if (!this.ideraDeclaration && this.questions[0].model == 24) {
          for (var i = 1; i <= 16; i++)
            this.questions[i].model = null;
          return false;
        } else {
          return true;
        }

      },
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      }
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>
